/*
 * @Auther: 罗耀祖
 * @Date: 2021-08-19 15:52:23
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-15 10:02:19
 * @name: 通用api
 * @Description: 通用api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\index\index.api.js
 * @Author: DESKTOP-1QU67QM
 */
import apiAdd from "../apiAdd.js";
import apiSearch from "../apiSearch.js";
import apiEdit from "../apiEdit.js";
import axios from 'axios';

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 上传图片
 * @param {Object} data ==> {myFile{File}: 图片文件}
 */
export const uploadImage = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  return apiAddInstance.post('/admin/upload/image.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 配置信息
 */
export const sysConfigDetail = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/sys_config/detail.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 更新配置
 * @param {Object} data ==> {settle_day{String}: 出账日,settle_limit_day{String}: 还账日,account{String}: 公司账户,account_name{String}: 公司户名,bank{String}: 收款银行}
 */
export const sysConfigEdit = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/sys_config/edit.html', data, instance);
}
